module.exports = __webpack_public_path__ + "static/media/optionSelected.ffc90b1d.png";